import styled from 'styled-components';

// CONSTANTS
import { GRAY_SUIT } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.ul`
  list-style: none;
  padding: 0;
  display: flex;
  align-items: center;

  ${breakpoints.down('xs')} {
    flex-wrap: wrap;
  }

  .info-list {
    &__item {
      display: flex;
      align-items: center;
      position: relative;

      &:not(:last-of-type) {
        margin-right: 24px;

        ${breakpoints.up('sm')} {
          padding-right: 24px;
        }

        &:after {
          ${breakpoints.up('sm')} {
            content: '';
            position: absolute;
            right: 0;
            width: 1px;
            height: 18px;
            background-color: ${GRAY_SUIT};
          }
        }
      }
    }

    &__title {
      margin-right: 5px;
    }
  }
`;

export default Container;
